<template>
  <div class="information mb-12">
    <v-container>
      <div class="two-row">
        <div class="custom-row end">
          <img class="icon mr-6 mb-5" src="~@/static/custom-img/chiling.png" alt="">
          <div class="text mb-6">
            {{ $t('onboardingSpecial.information.right.titleP1') }}
            <span>{{ $t('onboardingSpecial.information.right.titleP2') }}</span>
          </div>
          <div class="pluses">
            <div class="plus d-flex mb-6">
              <iconCheck class="flex-shrink-0 mr-3"/>
              <div class="plus-text">
                <b>{{ $t('onboardingSpecial.information.right.check1B') }}:</b>
                {{ $t('onboardingSpecial.information.right.check1') }}
              </div>
            </div>
            <div class="plus d-flex mb-6">
              <iconCheck class="flex-shrink-0 mr-3"/>
              <div class="plus-text">
                <b>{{ $t('onboardingSpecial.information.right.check2B') }}:</b>
                {{ $t('onboardingSpecial.information.right.check2') }}
              </div>
            </div>
            <div class="plus d-flex mb-6">
              <iconCheck class="flex-shrink-0 mr-3"/>
              <div class="plus-text">
                <b>{{ $t('onboardingSpecial.information.right.check3B') }}:</b>
                {{ $t('onboardingSpecial.information.right.check3') }}
              </div>
            </div>
            <div class="plus d-flex mb-6">
              <iconCheck class="flex-shrink-0 mr-3"/>
              <div class="plus-text">
                <b>{{ $t('onboardingSpecial.information.right.check4B') }}:</b>
                {{ $t( 'onboardingSpecial.information.right.check4') }}
              </div>
            </div>
            <div class="plus d-flex mb-6">
              <img class="icon-star flex-shrink-0 mr-3" src="~@/static/custom-img/iconStar60.png" alt="">
              <div class="plus-text">
                <b>{{ $t('onboardingSpecial.information.right.check5B') }}</b>
                {{ $t('onboardingSpecial.information.right.check5P1') }} <a href="mailto:support@moviemethod.com">support@moviemethod.com</a> {{ $t('onboardingSpecial.information.right.check5P2') }}
              </div>
            </div>
          </div>
        </div>

        <div class="custom-row">
          <div class="img-wrapper">
            <img class="phone-screens" src="~@/static/custom-img/phoneScreens.png" alt="">
            <img class="curso-rapido" src="~@/static/custom-img/cursoRapido.png" alt="">
          </div>

          <div class="prices mt-8">
            <div>{{ $t('onboardingSpecial.information.left.lifetimeOwnership') }} ….. $599</div>
            <div>{{ $t('onboardingSpecial.information.right.check2B') }} ….. $299</div>
          </div>

          <div class="divider my-4"></div>

          <div class="prices">
            <div class="total">{{ $t('onboardingSpecial.information.left.totalValue') }}:
              <span>
                $898
              </span>
            </div>
          </div>

          <div class="special-offer mt-7">
            <div class="special-offer-text">{{ $t('onboardingSpecial.information.left.newMemberSpecial') }} {{ $t('onboardingSpecial.information.left.oneTimeOffer') }}:
              <span v-if="!decline">$149</span>
              <span v-else>3 x $49</span>
            </div>
          </div>

          <div class="button-wrapper mt-4">
            <loaderButton
                className="upgrade-btn btn btn--sm btn--warmPink d-flex align-center justify-center"
                @click.stop.prevent="apply"
                :loading="loading"
            >
              <iconUpgrade class="icon-upgrade mr-2"/>
              <span>
                {{ $t('onboardingSpecial.information.left.upgradeMe') }}
              </span>
            </loaderButton>
          </div>

          <div @click="apply" class="desc yes mt-2">{{ $t('onboardingSpecial.information.left.yesUpgradeMe') }}</div>
          <div class="secure">
            <img src="~@/static/custom-img/secure.png" alt="">
          </div>
        </div>
      </div>

      <div
        @click="decline ? goToSuccess() : downgradeDialog = true"
        class="no mt-10"
      >
        {{ $t('onboardingSpecial.information.left.noThanks') }} {{ $t('onboardingSpecial.information.left.doNotWantLifetime') }}
      </div>
    </v-container>

    <v-dialog
      v-model="downgradeDialog"
      max-width="530"
      class="main_page_settings"
      :persistent="true"
    >
      <v-card>
        <modal @close="downgradeDialog = false" @apply="changeDecline" @cancel="goToSuccess"/>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="failedSubscriptionShow"
      max-width="530"
      class="main_page_settings"
      :persistent="true"
    >
      <v-card>
        <failedSubscriptionModal @close="failedSubscriptionShow = false" @changed="apply"/>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import iconCheck from '@/static/custom-img/iconCheck.svg';
import iconUpgrade from '@/static/custom-img/iconUpgrade.svg';
import modal from '@/components/onboarding/upgradePlan/modal';
import failedSubscriptionModal from '@/components/onboarding/upgradePlan/failedSubscriptionModal';
import loaderButton from '@/components/base/loaderButton';

export default {
  components: {
    iconCheck,
    iconUpgrade,
    modal,
    failedSubscriptionModal,
    loaderButton,
  },

  props: {
    decline: Boolean,
  },

  data () {
    return {
      failedSubscriptionShow: false,
      downgradeDialog: false,
      loading: false,
    };
  },

  computed: {
    user () {
      return this.$store.state.user.data.data;
    },
  },

  methods: {
    async apply () {
      if (this.loading) {
        return;
      }

      this.loading = true;
      this.failedSubscriptionShow = false;

      try {
        await this.$store.dispatch({
          type: 'user/PURCHASE_SPECIAL',
          data: { full: !this.decline },
        });
        this.loading = false;

        window.dataLayer && window.dataLayer.push({
          event: 'transactionComplete',
          transactionId: this.user ? `${this.user.email}/${new Date().getTime()}` : `noUser/${new Date().getTime()}`,
          transactionTotal: !this.decline ? 149 : 49.99,
          transactionProducts: [{
            sku: `Lifetime ${!this.decline ? '' : '3x Payment'} Plan`,
            name: `Lifetime ${!this.decline ? '' : '3x Payment'} Plan`,
            price: !this.decline ? 149 : 49.99,
            quantity: 1,
          }],
        });

        this.goToSuccess();
      } catch (error) {
        if (error.response && error.response.status === 402) {
          this.failedSubscriptionShow = true;
        }

        this.loading = false;
      }
    },

    goToSuccess () {
      this.$router.replace({ name: 'onboardingSuccess' });
    },

    changeDecline () {
      this.$emit('updateDecline', true);
      window.scrollTo(0, 0);
      this.downgradeDialog = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.icon {
  width: 232px;
  height: 173px;
}

.text {
  font-weight: bold;
  font-size: 26px;
  line-height: 32px;
  letter-spacing: -0.175px;
  color: #44445E;

  span {
    text-transform: uppercase;
  }
}

.plus {
  svg {
    width: 24px;
    height: 24px;
  }

  plus-text {
    font-size: 16px;
    line-height: 21px;
    letter-spacing: -0.175px;
    color: #44445E;
  }
}

.two-row {
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-gap: 67px;

  .end {
    justify-self: end;
  }

  > div {
    max-width: 480px;
  }

  @media #{map-get($display-breakpoints, 'xs-only')} {
    grid-template-columns: 1fr;

    > div {
      max-width: 100%
    }
  }
}

.icon-star {
  width: 81px;
  height: 81px;
}

.img-wrapper {
  position: relative;

  .phone-screens {
    max-width: 280px;
  }

  .curso-rapido {
    position: absolute;
    bottom: 0;
    width: 208px;
    left: 50%;
  }

  @media #{map-get($display-breakpoints, 'xs-only')} {
    .phone-screens {
     width: 70%
    }

    .curso-rapido {
      position: absolute;
      bottom: 0;
      width: 50%;
      left: 50%;
    }
  }
}

.prices {
  font-weight: bold;
  font-size: 18px;
  line-height: 26px;
  letter-spacing: -0.175px;
  color: #44445E;
}

.divider {
  width: 142px;
  height: 2px;
  background: #CFCFCF;
  border-radius: 2px;
}

.special-offer {
  width: 100%;
  max-width: 360px;
  font-weight: bold;
  font-size: 13px;
  line-height: 16px;
  letter-spacing: -0.175px;
  color: #FFFFFF;
  background-image: url('~@/static/custom-img/new-member.png');
  background-size: 100%;
  padding: 17px 20px;

  .special-offer-text {
    transform: rotate(-1.99deg);
  }

  @media #{map-get($display-breakpoints, 'xs-only')} {
    max-width: 290px;
    font-size: 12px;
    line-height: 15px;
    padding: 13px 9px;
  }
}

.icon-upgrade {
  width: 19px;
  height: 24px;
}

.button-wrapper {
  width: 100%;
  max-width: 360px;
  background-image: url('~@/static/custom-img/upgrade-bg.png');
  background-size: 100%;
  background-position: 50% 50%;
  padding: 30px;

  @media #{map-get($display-breakpoints, 'xs-only')} {
    max-width: 100%;
    padding: 14px;
  }
}

.upgrade-btn,
.desc {
  width: 100%;
  max-width: 360px;
}

.upgrade-btn {
  font-weight: bold;
  font-size: 28px;
  line-height: 34px;
  color: #73560B;
  background: #FFC83A;
  box-shadow: inset 0px -3px 0px rgba(0, 0, 0, 0.05);
  filter: drop-shadow(0px 0px 20px rgba(255, 184, 0, 0.6));
  border-radius: 4px;
  transition: all 250ms;
  backface-visibility: hidden;
  -webkit-font-smoothing: subpixel-antialiased;

  &:hover {
    transform: scale(1.02);
  }

  &::v-deep {
    &.btn--warmPink[disabled] {
      background: #FFC83A!important;
      color: #73560B!important;
    }
  }
}

.secure {
  text-align: center;
  width: 100%;
  max-width: 360px;

  img {
    width: 190px;
  }

  @media #{map-get($display-breakpoints, 'xs-only')} {
    max-width: 100%;
  }
}

.desc {
  font-weight: 500;
  font-size: 16px;
  line-height: 16px;
  text-align: center;
  letter-spacing: -0.175px;
  color: #44445E;
}

.yes {
  text-decoration-line: underline;
  color: #FA507B;
  cursor: pointer;
}

.no {
  font-weight: 500;
  font-size: 18px;
  line-height: 18px;
  text-align: center;
  letter-spacing: -0.175px;
  text-decoration-line: underline;
  color: #BCBCBC;
  cursor: pointer;
}

.link {
  letter-spacing: -0.175px;
  text-decoration-line: underline;
  text-transform: uppercase;
  font-weight: bold;
  color: #FA507B;
  cursor: pointer;
}

.total {
  span {
    position: relative;

    &::after {
      content: "";
      position: absolute;
      top: 50%;
      left: -1px;
      width: 110%;
      height: 2px;
      background-color: #FA507B;
      transform: rotate(350deg);
    }
  }
}

@media #{map-get($display-breakpoints, 'xs-only')} {
  .text {
    font-size: 16px;
    line-height: 19px;

    span {
      font-size: 18px;
      line-height: 22px;
    }
  }

  .plus {
    .plus-text {
      font-size: 14px;
      line-height: 20px;
    }
  }

  .prices {
    font-size: 13px;
    line-height: 18px;
  }

  .total {
    font-size: 16px;
    line-height: 19px;
  }

  .desc {
    font-size: 14px;
    line-height: 14px;
  }

  .desc,
  .upgrade-btn {
    max-width: none;
  }

  .information {
    .container {
      padding: 0;
    }
  }

}

</style>
